import CMS from './module_CMS';

export default CMS;
